import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SportResult: FC<SvgIconProps> = (props) => (
  <SvgIcon width="100%" height="100%" viewBox="0 0 512 512" {...props}>
    <g>
      <path
        className="st0"
        d="M271,332.6h241v-226c0-8.3-6.7-15-15-15H271V332.6z M342.6,212.1c0-8.3,6.7-15,15-15h52.8v-37.8h-52.8
		c-8.3,0-15-6.7-15-15s6.7-15,15-15h67.8c8.3,0,15,6.7,15,15v67.8c0,8.3-6.7,15-15,15h-52.8v37.8h52.8c8.3,0,15,6.7,15,15
		s-6.7,15-15,15h-67.8c-8.3,0-15-6.7-15-15L342.6,212.1L342.6,212.1z"
      />
      <path
        className="st0"
        d="M241,91.6H15c-8.3,0-15,6.7-15,15v226h241V91.6z M169.4,279.9c0,8.3-6.7,15-15,15s-15-6.7-15-15v-52.8H86.6
		c-8.3,0-15-6.7-15-15v-67.8c0-8.3,6.7-15,15-15s15,6.7,15,15v52.8h37.8v-52.8c0-8.3,6.7-15,15-15s15,6.7,15,15V279.9z"
      />
      <path className="st0" d="M0,362.6v42.8c0,8.3,6.7,15,15,15h482c8.3,0,15-6.7,15-15v-42.8H0z" />
    </g>
  </SvgIcon>
);

export default SportResult;
